import styled from 'styled-components';

const CourseStoreStyle = styled.div`
    .user-menu-title{
        font-size: 1.424rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
        word-break: break-word;
        hyphens: auto;
        text-align: left;
        margin-bottom: 10px;
    }
    .collection_title{
        font-size: 1.266rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
        word-break: break-word;
        hyphens: auto;
        text-align: justify;
        margin-bottom: 12px;
    }
    .course_store_collapse{
        border: none;
        background-color: none;
        .ant-collapse-content{
            border: none;
        }
        .ant-collapse-header-text{
            text-align: left;
        }
        .collaple_checkbox_header{
            text-wrap: nowrap;
        }
    }
    .users-menu-filter-container{
        display: flex;
        gap: 8px;
    }
    .children_checkbox_collection{
        display: flex;
        flex-direction: column;
        // align-items: center;
        text-align: justify;
        gap: 8px;
        margin: 0;
    }
    .course-card-box{
        width: 30%;
        border-radius: 4px;
        cursor: pointer;
        background-color: rgb(255, 255, 255);
        box-shadow: rgb(193, 197, 200) 0px 0px 10px;
        
    }
    .Course-image-poster{
        width: 100%;
    }
    .collections-data-container{
        flex-flow: unset;
        gap: 10px;
    }
    .course-card-box-container{
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    }
    .view-more-button{
        margin-top: 30px;
        width: 100%;
        padding: 0;
        background-color: rgb(27, 104, 179);
        color: #fff;
        border: none;
        &:hover{
            background-color: rgb(27, 104, 179) !important;
            color: #fff !important;
            border: none;
        }
    }
    .languages-section{
        text-align: justify;
    }
    .subscribe_banner{
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1rem;
        width: 100%;
        min-height: 4rem;
        border-radius: 5px;
        background: rgba(116, 176, 234, 0.25);

        p{
            font-size: 0.889rem;
            font-weight: 400;
        }
        Button{
            color: rgb(255, 255, 255);
            background-color: rgb(27, 104, 179);
            border: 1px solid rgb(27, 104, 179);
        }
    }

    .view_course_header_container{
        width: 100%;
        background-color: rgb(16, 62, 107);
        position: relative;
        // display: flex;
        // -webkit-box-pack: center;
        // justify-content: center;
        padding: 12px;
        border-radius: 8px;
    }
    .back_icon_section{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin-bottom: 16px;
        color: rgb(255, 255, 255);
        background-color: rgba(116, 176, 234, 0.25);
        border: 1px solid transparent;
        height: 30px;
        width: 30px;
        border-radius: 8px;
        .back_icon{
            rotate: 90deg;
            font-size: 22px;
        }
    }
    .view_course_left_details{
        text-align: justify;
    }
    .view_course_header_contents{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-flow: unset;
        gap: 12px;
    }
    .spancontent{
        word-break: break-word;
        font-style: italic;
        font-size: 0.889rem;
        font-weight: 400;
        color: #fff;
    }
    .course_name{
        font-size: 1.802rem;
        font-weight: 700;
        color: #fff;
    }
    .course_code{
        font-size: 0.889rem;
        font-weight: 400;
        color: #fff;
    }
    .you_tube_player_container{
        width: 50%;
        // background: red;
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 12px;
        img{
            aspect-ratio: 1 / 0.6;
        }
    }
    .content_container{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        word-break: break-word;
    }
    .content_details_sentence{
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        word-break: break-word;
        font-size: 1rem;
        font-weight: 400;
    }
    .sort_by_dropdown{
        height: 2.5rem;
        min-width: 2.5rem;
        // background-color: rgb(245, 245, 246) !important;
        color: #000 !important;
        border: 1px solid #d9d9d9 !important;
        Button{
            height: 2.5rem;
            min-width: 2.5rem;
            // background-color: rgb(245, 245, 246) !important;
            color: #000 !important;
            border: 1px solid #d9d9d9 !important;
            &:hover{
                border: 1px solid #d9d9d9 !important;
                // background-color: rgb(245, 245, 246) !important;
                color: #000 !important;
            }
        } 
    }
    .course_card_search{
        height: 2.5rem;
        min-width: 2.5rem;
    }
    .search-input-field {
        margin-bottom: 0px !important;
        .ant-input-affix-wrapper{
            height: 2.5rem;
        }
    }
`;

export default CourseStoreStyle;